import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';


@Injectable({
  providedIn: 'root'
})
export class ServiceCatalogueService {
  public baseURL: string;
 // private baseURL = environment.AppUrl + '/api/App/'
  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.baseURL = this.appConfig.getAppConfig().AppUrl + '/api/App/';
  }

  GetMTTmodules(params){
    return this.http.get(this.baseURL + 'GetMTTmodules', {params: params});
  }

  GetServiceDeclarations(params){
    return this.http.get(this.baseURL + 'GetServiceDeclarations', {params: params});
  }

  GetmoduleServices(params){
    return this.http.get(this.baseURL + 'GetmoduleServices', {params: params});
  }


  // onGetModules(params){
  //   return this.http.get(this.baseURL + url, {params: params});
  // }
  
}
